import { render, staticRenderFns } from "./VrScene.vue?vue&type=template&id=103107b6&scoped=true"
import script from "./VrScene.vue?vue&type=script&lang=js"
export * from "./VrScene.vue?vue&type=script&lang=js"
import style0 from "./VrScene.vue?vue&type=style&index=0&id=103107b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103107b6",
  null
  
)

export default component.exports